import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

import { ref, computed, onMounted, onUnmounted }    from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import {Chart} from 'highcharts-vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useTheme } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { getOptionsInGraphs } from '@/functions/project';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTGRAPHS from '@/constants/graphs';
import { STRING_GENERAL } from '@/constants/labels';

/********************************
 ********** INTERFACES **********
 *******************************/
interface Tooltip {
  formatter?: (this: { value?: number, y?:number, x?:number, color?:string }) => string;
  valueDecimals? : number;
}
 

export default /*#__PURE__*/_defineComponent({
  __name: 'SingleChart',
  props: {
    firstArray:{ required:true, type:Array },
    name:{ type:String, required:true },
    title:{ required:true, type: String },
    color:{ required:true },
    isactive:{ type:Boolean, default: false }
},
  setup(__props) {

const props = __props;

const theme = useTheme();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 *********** FUNCTION ***********
 *******************************/

        
    /**
     * Vue / Vuetify
     */


const colorText             = computed(() => theme.global.current.value.colors.colorText)
const zones                 = ref(CONSTGRAPHS.ZONES[props.name] || []);
const potLine               = CONSTGRAPHS.POTLINE[props.name];

const principalData         = computed(() => props.firstArray)

const type                  = ref(CONSTGRAPHS.TYPE_GRAPH[props.name] || null);
const reversed              = ref(props.name === STRING_GENERAL.rssi || props.name === STRING_GENERAL.rsrp || props.name === STRING_GENERAL.rsrq ? true : false)
const yAxisTitle            = ref(CONSTGRAPHS.YAXISLABEL[props.name] || '');
const yourLabels            = [ t('labels.down'), t('labels.alarm'), t('labels.alert'), t('labels.ok')];
const labels:Tooltip        = props.name === 'Status' ? 
{
    formatter: function(){
        return yourLabels[this.value??0];
    }
} : 
{};

const dataGrouping = props.name === STRING_GENERAL.Status || props.name === STRING_GENERAL.rssi || props.name === STRING_GENERAL.rsrp || props.name === STRING_GENERAL.rsrq ? {
approximation: 'average', 
enabled: true,
} : props.name === STRING_GENERAL.Voltage || props.name === STRING_GENERAL.Cost || props.name === STRING_GENERAL.temperature ? {
    approximation: 'average', 
    enabled: false,
} : {};

const tooltip:Tooltip =  props.name === STRING_GENERAL.Status ? {
    formatter: function(){

        const valor         = this.x;
        const newDate       = new Date(valor as number);
        const partsOfDate   = newDate.toString().split(' ');

        const finalDate = `${partsOfDate[1]} ${partsOfDate[2]} ${partsOfDate[3]} ${partsOfDate[4]}`; 

        var label;
        
        switch(true){
            case ((this.y??0) >= 0 && (this.y??0) < 1):
                label = t('labels.down');
                break;
            case ((this.y??0) >= 1 && (this.y??0) < 2):
                label = t('labels.alarm');
                break;
            case ((this.y??0) >= 2 && (this.y??0) < 3):
                label = t('labels.alert');
                break;
            case ((this.y??0) == 3):
                label = t('labels.ok');
                break;
        }
        return '<b> Valor: ' + label + '<br/>Fecha: ' + finalDate;
    },
    
} : props.name === 'cpu'  ? {
    formatter: function(){
        return t('labels.cpu') + `: ` + (this.y??0) + ' %' ;
    }
} : props.name === 'memoria' ? {
    formatter: function(){
        return t('labels.memo') + `: ` + (this.y??0) + ' %' ;
    }
} : props.name === 'disco' ? {
    formatter: function(){ 
        return t('labels.disc') + `: ` + (this.y??0) + ' %' ;
    }
} : props.name === 'temperature' ? {
    formatter: function(){ 
        return t('labels.temperature')+ `: <b>`  + (this.y??0) + '° C' ;
    }
} : props.name === 'voltage' ? {
    formatter: function(){ 
        return t('labels.voltage')+ `: <b>` + (this.y??0) + ' V' ;
    }
} : props.name === 'Latency' ? {
    formatter: function(){ 
        return t('labels.latency')+ `: <b>` +(this.y??0) + ' ms' ;
    }
} : { valueDecimals: 2 };


const finalYAxis = ref({
        reversed:reversed,
        title: {
            text: yAxisTitle,
            style:{ color: colorText }
        },
        plotLines: [ {
            value: potLine,
            color: 'red',
            dashStyle: 'shortdash',
            width: 2,
            label: { text:  props.name === 'Latency' ? '100ms' : potLine + ' V' }
        }],
        labels: labels,
        style: { color: colorText }
})
const finalSeries = ref([
        {
            type: type,
            name: props.name,
            data: principalData.value,
            color:props.color,
            zones:zones.value,
            dataGrouping: dataGrouping,
            linecap: 'round'
        }
])
/* eslint-disable */
/**
 * getOptionsInGraphs(tipo, serie, titulo, subtitulo, ocultar leyenda, altura, tooltip, yaxis)
 */
const finalOptions:any = ref(getOptionsInGraphs('line',finalSeries.value,props.title,'',false,550,tooltip,finalYAxis));


const isactive = ref(false);

const onClickOutside = () => {
    isactive.value = false;
}

const activeClick = () =>{
    isactive.value = true;
}


const chartRef = ref<any>();
const duplicateChart = ref();

onMounted(async () => {
    setTimeout(() => {
        duplicateChart.value = chartRef.value;
    }, 500);
});

onUnmounted(() => {
    if(duplicateChart.value){
        duplicateChart.value.chart.destroy();
    }
});

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_sheet, {
    color: "transparent",
    class: "containerAreaSheet",
    onClick: activeClick
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Chart), {
        class: _normalizeClass([isactive.value ? 'borderActive' : '', "hc"]),
        ref_key: "chartRef",
        ref: chartRef,
        constructorType: 'stockChart',
        options: finalOptions.value
      }, null, 8, ["class", "options"]),
      (!isactive.value)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            class: "areaChartSheet"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  })), [
    [_directive_click_outside, {handler: onClickOutside}]
  ])
}
}

})